export default "__VITE_ASSET__CSWzgQQD__"